import React from 'react';
import Searchbox from './Searchbox';
import './style.css';

export default function Finder() {
  return (
    <div className="app-body-main">
      <div className="mt-4 p-3 py-5 app-body-center col-12 bg-white shadow-sm inst-search-box">
        <Searchbox />
      </div>
    </div>
  );
}
